// 语言包导出文件
import zhWorkflow from './zh/workflow.json';
import enWorkflow from './en/workflow.json';

// 语言包资源对象
export const resources = {
  zh: {
    workflow: zhWorkflow,
  },
  en: {
    workflow: enWorkflow,
  },
} as const;

